import React from 'react';

const H3ChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5 20v-6h7v6h2V6h-2v6H5V6H3v14h2zM18.4 11.1c1.6 0 2.6-.7 2.6-2 0-.8-.5-1.5-1.5-1.7.8-.2 1.3-.8 1.3-1.5 0-1.1-.8-1.7-2.2-1.7-.9 0-1.9.3-2.5.9l.8.9c.5-.5 1-.6 1.5-.6.7 0 1 .3 1 .7 0 .4-.2.8-1.4.8h-.4V8h.3c1.1 0 1.6.2 1.6 1 0 .6-.4.9-1.1.9-.5 0-1.2-.3-1.6-.8l-1 .9c.6.7 1.5 1.1 2.6 1.1z"
        />
    </svg>
);

H3ChunkySvg.displayName = 'H3ChunkySvg';
export default H3ChunkySvg;
